<template>
    <div class="fields-restricted-manager">
        <div class="alert alert-info" role="alert">
            Sélectionnez les champs que vous souhaitez restreindre. Cocher une catégorie sélectionnera tous ses
            sous-éléments.
        </div>

        <div class="row">
            <!-- Colonne gauche : API + Champs supplémentaires -->
            <div class="col-md-6">
                <div class="card mb-4" v-if="categories['api']">
                    <div class="card-header">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"
                                   id="category-api"
                                   v-model="allCheckedCategories['api']"
                                   @change="toggleCategory('api')">
                            <label class="custom-control-label" for="category-api">
                                <strong>{{ getCategoryName('api') }}</strong>
                            </label>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-for="(subcategory, subcategoryKey) in categories['api']"
                             :key="`api-${subcategoryKey}`"
                             class="mb-3">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                       :id="`subcategory-api-${subcategoryKey}`"
                                       v-model="allCheckedSubcategories['api'][subcategoryKey]"
                                       @change="toggleSubcategory('api', subcategoryKey)">
                                <label class="custom-control-label"
                                       :for="`subcategory-api-${subcategoryKey}`">
                                    <strong>{{ subcategoryKey }}</strong>
                                </label>
                            </div>
                            <div class="ml-4 mt-2">
                                <div v-for="field in getFields('api', subcategoryKey)"
                                     :key="`api-${subcategoryKey}-${field}`"
                                     class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           :id="`field-api-${subcategoryKey}-${field}`"
                                           v-model="selectedFields['api'][subcategoryKey][field]"
                                           @change="updateSelectionState('api', subcategoryKey)">
                                    <label class="custom-control-label"
                                           :for="`field-api-${subcategoryKey}-${field}`">
                                        {{ field }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Champs supplémentaires opt-in -->
                <template v-if="hasAllowedCategories">
                    <div class="alert alert-success" role="alert">
                        Champs supplémentaires : sélectionnez les champs à <strong>activer</strong> pour cet utilisateur.
                        Ces champs sont masqués par défaut.
                    </div>

                    <div class="card mb-4" v-for="(allowedCategory, allowedCategoryKey) in allowedCategories" :key="`allowed-${allowedCategoryKey}`">
                        <div class="card-header">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                       :id="`allowed-category-${allowedCategoryKey}`"
                                       v-model="allCheckedAllowedCategories[allowedCategoryKey]"
                                       @change="toggleAllowedCategory(allowedCategoryKey)">
                                <label class="custom-control-label" :for="`allowed-category-${allowedCategoryKey}`">
                                    <strong>{{ getAllowedCategoryName(allowedCategoryKey) }}</strong>
                                </label>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-for="(subcategory, subcategoryKey) in allowedCategory"
                                 :key="`allowed-${allowedCategoryKey}-${subcategoryKey}`"
                                 class="mb-3">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           :id="`allowed-subcategory-${allowedCategoryKey}-${subcategoryKey}`"
                                           v-model="allCheckedAllowedSubcategories[allowedCategoryKey][subcategoryKey]"
                                           @change="toggleAllowedSubcategory(allowedCategoryKey, subcategoryKey)">
                                    <label class="custom-control-label"
                                           :for="`allowed-subcategory-${allowedCategoryKey}-${subcategoryKey}`">
                                        <strong>{{ subcategoryKey }}</strong>
                                    </label>
                                </div>
                                <div class="ml-4 mt-2">
                                    <div v-for="field in getAllowedFields(allowedCategoryKey, subcategoryKey)"
                                         :key="`allowed-${allowedCategoryKey}-${subcategoryKey}-${field}`"
                                         class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`allowed-field-${allowedCategoryKey}-${subcategoryKey}-${field}`"
                                               v-model="selectedAllowedFields[allowedCategoryKey][subcategoryKey][field]"
                                               @change="updateAllowedSelectionState(allowedCategoryKey, subcategoryKey)">
                                        <label class="custom-control-label"
                                               :for="`allowed-field-${allowedCategoryKey}-${subcategoryKey}-${field}`">
                                            {{ field }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <!-- Colonne droite : Export/Affichage -->
            <div class="col-md-6">
                <div class="card mb-4" v-if="categories['export']">
                    <div class="card-header">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"
                                   id="category-export"
                                   v-model="allCheckedCategories['export']"
                                   @change="toggleCategory('export')">
                            <label class="custom-control-label" for="category-export">
                                <strong>{{ getCategoryName('export') }}</strong>
                            </label>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-for="(subcategory, subcategoryKey) in categories['export']"
                             :key="`export-${subcategoryKey}`"
                             class="mb-3">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                       :id="`subcategory-export-${subcategoryKey}`"
                                       v-model="allCheckedSubcategories['export'][subcategoryKey]"
                                       @change="toggleSubcategory('export', subcategoryKey)">
                                <label class="custom-control-label"
                                       :for="`subcategory-export-${subcategoryKey}`">
                                    <strong>{{ subcategoryKey }}</strong>
                                </label>
                            </div>
                            <div class="ml-4 mt-2">
                                <div v-for="field in getFields('export', subcategoryKey)"
                                     :key="`export-${subcategoryKey}-${field}`"
                                     class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           :id="`field-export-${subcategoryKey}-${field}`"
                                           v-model="selectedFields['export'][subcategoryKey][field]"
                                           @change="updateSelectionState('export', subcategoryKey)">
                                    <label class="custom-control-label"
                                           :for="`field-export-${subcategoryKey}-${field}`">
                                        {{ field }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <input type="hidden" name="fields_restricted" :value="JSON.stringify(computedSelectedFieldsForDatas)">
        <input type="hidden" name="fields_allowed" :value="JSON.stringify(computedSelectedAllowedFieldsForDatas)">
    </div>
</template>

<script>
export default {
    props: {
        userFieldsRestricted: {
            type: String,
            default: '{}'
        },
        userFieldsAllowed: {
            type: String,
            default: '{}'
        },
        fieldsConfig: {
            type: String,
            required: true
        },
        fieldsAllowedConfig: {
            type: String,
            default: '{}'
        }
    },

    data() {
        return {
            categories: {},
            selectedFields: {},
            allCheckedCategories: {},
            allCheckedSubcategories: {},
            computedSelectedFieldsForDatas: {},
            allowedCategories: {},
            selectedAllowedFields: {},
            allCheckedAllowedCategories: {},
            allCheckedAllowedSubcategories: {},
            computedSelectedAllowedFieldsForDatas: {}
        }
    },

    computed: {
        hasAllowedCategories() {
            return Object.keys(this.allowedCategories).length > 0;
        }
    },

    mounted() {
        this.initializeData();
    },
    watch: {
        selectedFields: {
            deep: true,
            handler() {
                this.computedSelectedFieldsForDatas = this.getSelectedFieldsForSubmit();
            }
        },
        allCheckedCategories: {
            deep: true,
            handler() {
                this.computedSelectedFieldsForDatas = this.getSelectedFieldsForSubmit();
            }
        },
        allCheckedSubcategories: {
            deep: true,
            handler() {
                this.computedSelectedFieldsForDatas = this.getSelectedFieldsForSubmit();
            }
        },
        selectedAllowedFields: {
            deep: true,
            handler() {
                this.computedSelectedAllowedFieldsForDatas = this.getSelectedAllowedFieldsForSubmit();
            }
        },
        allCheckedAllowedCategories: {
            deep: true,
            handler() {
                this.computedSelectedAllowedFieldsForDatas = this.getSelectedAllowedFieldsForSubmit();
            }
        },
        allCheckedAllowedSubcategories: {
            deep: true,
            handler() {
                this.computedSelectedAllowedFieldsForDatas = this.getSelectedAllowedFieldsForSubmit();
            }
        }
    },


    methods: {
        initializeData() {
            // Charger et parser la configuration des champs
            this.categories = JSON.parse(this.fieldsConfig);
            this.allowedCategories = JSON.parse(this.fieldsAllowedConfig);

            // Initialiser les structures de données
            this.initializeSelectionStructures();
            this.initializeAllowedSelectionStructures();

            // Charger les restrictions existantes
            this.loadExistingRestrictions();
            this.loadExistingAllowed();

            // Mettre à jour l'état des cases à cocher
            this.updateAllCategoriesState();
            this.updateAllAllowedCategoriesState();

            // Initialiser les champs cachés avec les valeurs actuelles
            this.computedSelectedFieldsForDatas = this.getSelectedFieldsForSubmit();
            this.computedSelectedAllowedFieldsForDatas = this.getSelectedAllowedFieldsForSubmit();
        },

        initializeSelectionStructures() {
            this.selectedFields = {};
            this.allCheckedCategories = {};
            this.allCheckedSubcategories = {};

            // Créer la structure pour chaque catégorie et sous-catégorie
            for (const categoryKey in this.categories) {
                this.selectedFields[categoryKey] = {};
                this.allCheckedSubcategories[categoryKey] = {};
                this.allCheckedCategories[categoryKey] = false;

                for (const subcategoryKey in this.categories[categoryKey]) {
                    this.selectedFields[categoryKey][subcategoryKey] = {};
                    this.allCheckedSubcategories[categoryKey][subcategoryKey] = false;

                    // Initialiser chaque champ à false
                    const fields = this.getFields(categoryKey, subcategoryKey);
                    fields.forEach(field => {
                        this.selectedFields[categoryKey][subcategoryKey][field] = false;
                    });
                }
            }
        },

        initializeAllowedSelectionStructures() {
            this.selectedAllowedFields = {};
            this.allCheckedAllowedCategories = {};
            this.allCheckedAllowedSubcategories = {};

            for (const categoryKey in this.allowedCategories) {
                this.selectedAllowedFields[categoryKey] = {};
                this.allCheckedAllowedSubcategories[categoryKey] = {};
                this.allCheckedAllowedCategories[categoryKey] = false;

                for (const subcategoryKey in this.allowedCategories[categoryKey]) {
                    this.selectedAllowedFields[categoryKey][subcategoryKey] = {};
                    this.allCheckedAllowedSubcategories[categoryKey][subcategoryKey] = false;

                    const fields = this.getAllowedFields(categoryKey, subcategoryKey);
                    fields.forEach(field => {
                        this.selectedAllowedFields[categoryKey][subcategoryKey][field] = false;
                    });
                }
            }
        },

        loadExistingRestrictions() {
            const userFieldsRestricted = JSON.parse(this.userFieldsRestricted || '{}');

            for (const categoryKey in userFieldsRestricted) {
                if (!this.selectedFields[categoryKey]) continue;
                if (Array.isArray(userFieldsRestricted[categoryKey])) {
                    // Obtenir la liste des champs restreints pour cette catégorie
                    const fieldsToRestrict = userFieldsRestricted[categoryKey];

                    // Parcourir toutes les sous-catégories de cette catégorie
                    for (const subcategoryKey in this.selectedFields[categoryKey]) {
                        // Parcourir tous les champs de cette sous-catégorie
                        const fields = this.getFields(categoryKey, subcategoryKey);

                        let allFieldsChecked = true;

                        fields.forEach(field => {
                            // Vérifier si ce champ est dans la liste des champs restreints
                            if (fieldsToRestrict.includes(field)) {
                                // Si oui, le marquer comme coché
                                this.$set(this.selectedFields[categoryKey][subcategoryKey], field, true);
                            } else {
                                allFieldsChecked = false;
                            }
                        });

                        // Mettre à jour l'état de la sous-catégorie
                        this.$set(this.allCheckedSubcategories[categoryKey], subcategoryKey, allFieldsChecked);
                    }

                    // Mettre à jour l'état de la catégorie
                    this.updateCategoryState(categoryKey);
                }
            }
        },

        loadExistingAllowed() {
            const userFieldsAllowed = JSON.parse(this.userFieldsAllowed || '{}');

            for (const categoryKey in userFieldsAllowed) {
                if (!this.selectedAllowedFields[categoryKey]) continue;
                if (Array.isArray(userFieldsAllowed[categoryKey])) {
                    const fieldsToAllow = userFieldsAllowed[categoryKey];

                    for (const subcategoryKey in this.selectedAllowedFields[categoryKey]) {
                        const fields = this.getAllowedFields(categoryKey, subcategoryKey);
                        let allFieldsChecked = true;

                        fields.forEach(field => {
                            if (fieldsToAllow.includes(field)) {
                                this.$set(this.selectedAllowedFields[categoryKey][subcategoryKey], field, true);
                            } else {
                                allFieldsChecked = false;
                            }
                        });

                        this.$set(this.allCheckedAllowedSubcategories[categoryKey], subcategoryKey, allFieldsChecked);
                    }

                    this.updateAllowedCategoryState(categoryKey);
                }
            }
        },

        getFields(categoryKey, subcategoryKey) {
            return Object.keys(this.categories[categoryKey][subcategoryKey] || {});
        },

        getAllowedFields(categoryKey, subcategoryKey) {
            return Object.keys(this.allowedCategories[categoryKey][subcategoryKey] || {});
        },

        toggleCategory(categoryKey) {
            const isChecked = this.allCheckedCategories[categoryKey];

            // Mettre à jour toutes les sous-catégories et leurs champs
            for (const subcategoryKey in this.categories[categoryKey]) {
                this.$set(this.allCheckedSubcategories[categoryKey], subcategoryKey, isChecked);

                const fields = this.getFields(categoryKey, subcategoryKey);
                fields.forEach(field => {
                    this.$set(this.selectedFields[categoryKey][subcategoryKey], field, isChecked);
                });
            }
            this.$forceUpdate();
            this.computedSelectedFieldsForDatas = this.getSelectedFieldsForSubmit();
        },

        toggleAllowedCategory(categoryKey) {
            const isChecked = this.allCheckedAllowedCategories[categoryKey];

            for (const subcategoryKey in this.allowedCategories[categoryKey]) {
                this.$set(this.allCheckedAllowedSubcategories[categoryKey], subcategoryKey, isChecked);

                const fields = this.getAllowedFields(categoryKey, subcategoryKey);
                fields.forEach(field => {
                    this.$set(this.selectedAllowedFields[categoryKey][subcategoryKey], field, isChecked);
                });
            }
            this.$forceUpdate();
            this.computedSelectedAllowedFieldsForDatas = this.getSelectedAllowedFieldsForSubmit();
        },

        toggleSubcategory(categoryKey, subcategoryKey) {
            const isChecked = this.allCheckedSubcategories[categoryKey][subcategoryKey];

            // Mettre à jour tous les champs de cette sous-catégorie
            const fields = this.getFields(categoryKey, subcategoryKey);
            fields.forEach(field => {
                this.$set(this.selectedFields[categoryKey][subcategoryKey], field, isChecked);
            });

            // Mettre à jour l'état de la catégorie parente
            this.updateCategoryState(categoryKey);
            this.$forceUpdate();
            this.computedSelectedFieldsForDatas = this.getSelectedFieldsForSubmit();
        },

        toggleAllowedSubcategory(categoryKey, subcategoryKey) {
            const isChecked = this.allCheckedAllowedSubcategories[categoryKey][subcategoryKey];

            const fields = this.getAllowedFields(categoryKey, subcategoryKey);
            fields.forEach(field => {
                this.$set(this.selectedAllowedFields[categoryKey][subcategoryKey], field, isChecked);
            });

            this.updateAllowedCategoryState(categoryKey);
            this.$forceUpdate();
            this.computedSelectedAllowedFieldsForDatas = this.getSelectedAllowedFieldsForSubmit();
        },

        updateSelectionState(categoryKey, subcategoryKey) {
            this.updateSubcategoryState(categoryKey, subcategoryKey);
            this.updateCategoryState(categoryKey);
            this.computedSelectedFieldsForDatas = this.getSelectedFieldsForSubmit();
        },

        updateAllowedSelectionState(categoryKey, subcategoryKey) {
            this.updateAllowedSubcategoryState(categoryKey, subcategoryKey);
            this.updateAllowedCategoryState(categoryKey);
            this.computedSelectedAllowedFieldsForDatas = this.getSelectedAllowedFieldsForSubmit();
        },

        updateSubcategoryState(categoryKey, subcategoryKey) {
            // Vérifier si tous les champs de cette sous-catégorie sont sélectionnés
            const fields = this.getFields(categoryKey, subcategoryKey);
            const allChecked = fields.every(field =>
                this.selectedFields[categoryKey][subcategoryKey][field]
            );

            this.allCheckedSubcategories[categoryKey][subcategoryKey] = allChecked;
        },

        updateAllowedSubcategoryState(categoryKey, subcategoryKey) {
            const fields = this.getAllowedFields(categoryKey, subcategoryKey);
            const allChecked = fields.every(field =>
                this.selectedAllowedFields[categoryKey][subcategoryKey][field]
            );

            this.allCheckedAllowedSubcategories[categoryKey][subcategoryKey] = allChecked;
        },

        updateCategoryState(categoryKey) {
            // Vérifier si toutes les sous-catégories sont sélectionnées
            const allChecked = Object.keys(this.allCheckedSubcategories[categoryKey]).every(
                subcategoryKey => this.allCheckedSubcategories[categoryKey][subcategoryKey]
            );

            this.allCheckedCategories[categoryKey] = allChecked;
        },

        updateAllowedCategoryState(categoryKey) {
            const allChecked = Object.keys(this.allCheckedAllowedSubcategories[categoryKey]).every(
                subcategoryKey => this.allCheckedAllowedSubcategories[categoryKey][subcategoryKey]
            );

            this.allCheckedAllowedCategories[categoryKey] = allChecked;
        },

        updateAllCategoriesState() {
            // Mettre à jour l'état de toutes les catégories
            for (const categoryKey in this.categories) {
                this.updateCategoryState(categoryKey);
            }
        },

        updateAllAllowedCategoriesState() {
            for (const categoryKey in this.allowedCategories) {
                this.updateAllowedCategoryState(categoryKey);
            }
        },

        getCategoryName(categoryKey) {
            const names = {
                'api': 'API',
                'export': 'Export/Affichage'
            };

            return names[categoryKey] || categoryKey;
        },

        getAllowedCategoryName(categoryKey) {
            const names = {
                'api': 'API - Champs supplémentaires'
            };

            return names[categoryKey] || categoryKey;
        },

        getSelectedFieldsForSubmit() {
            const result = {};

            for (const categoryKey in this.selectedFields) {
                result[categoryKey] = [];

                for (const subcategoryKey in this.selectedFields[categoryKey]) {
                    // Récupérer tous les champs sélectionnés dans cette sous-catégorie
                    for (const field in this.selectedFields[categoryKey][subcategoryKey]) {
                        if (this.selectedFields[categoryKey][subcategoryKey][field]) {
                            // Ajouter le champ individuel à la liste
                            result[categoryKey].push(field);
                        }
                    }
                }

                if (result[categoryKey].length === 0) {
                    delete result[categoryKey];
                }
            }

            return result;
        },

        getSelectedAllowedFieldsForSubmit() {
            const result = {};

            for (const categoryKey in this.selectedAllowedFields) {
                result[categoryKey] = [];

                for (const subcategoryKey in this.selectedAllowedFields[categoryKey]) {
                    for (const field in this.selectedAllowedFields[categoryKey][subcategoryKey]) {
                        if (this.selectedAllowedFields[categoryKey][subcategoryKey][field]) {
                            result[categoryKey].push(field);
                        }
                    }
                }

                if (result[categoryKey].length === 0) {
                    delete result[categoryKey];
                }
            }

            return result;
        }
    }
}
</script>

<style scoped>
.fields-restricted-manager {
    margin-bottom: 20px;
}
</style>
